import { useState, useEffect, useCallback } from "react";
import { 
  getExpertServicesForLearners, 
  getExpertServiceDetails,
  purchaseExpertService,
  getPurchasedExpertServices
} from "PlatForms/SelfLMS/Services/ExpertService/ExpertServiceLearner";
import { message } from "antd";
import { toast } from "react-toastify";

export const useExpertServiceLearner = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [purchasedServices, setPurchasedServices] = useState([]);
const [purchasedServicesLoading, setPurchasedServicesLoading] = useState(false);
const [purchasedServicesError, setPurchasedServicesError] = useState(null);
const [purchasedServicesPagination, setPurchasedServicesPagination] = useState({
  totalCount: 0,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 1
});

//  fetch purchased services
const fetchPurchasedServices = useCallback(async (page = 1) => {
  setPurchasedServicesLoading(true);
  setPurchasedServicesError(null);
  
  try {
    const params = {
      pageNumber: page,
      pageSize: purchasedServicesPagination.pageSize
    };
    
    const data = await getPurchasedExpertServices(params);
    setPurchasedServices(data.items || []);
    setPurchasedServicesPagination({
      totalCount: data.totalCount,
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
      totalPages: data.totalPages
    });
  } catch (err) {
    setPurchasedServicesError(err.message || "Failed to fetch purchased services");
    message.error("Failed to load purchased expert services");
  } finally {
    setPurchasedServicesLoading(false);
  }
}, [purchasedServicesPagination.pageSize]);


  // Fetch all services
  const fetchServices = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);
    
    try {
      const params = {
        pageNumber: page,
        pageSize: pagination.pageSize,
        search: searchTerm
      };
      
      const data = await getExpertServicesForLearners(params);
      console.log(".........................services on learner",data);
      setServices(data.items || []);
      setPagination({
        totalCount: data.totalCount,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
        totalPages: data.totalPages
      });
    } catch (err) {
      setError(err.message || "Failed to fetch services");
      message.error("Failed to load expert services");
    } finally {
      setLoading(false);
    }
  }, [searchTerm, pagination.pageSize]);

  // Get service details
  const getServiceDetails = async (serviceId) => {
    try {
      return await getExpertServiceDetails(serviceId);
    } catch (err) {
      message.error("Failed to load service details");
      throw err;
    }
  };

  // Purchase a service
const purchaseService = async (pricingId) => {
  try {
    const purchaseResponse = await purchaseExpertService(pricingId);
    console.log("Purchase response:", purchaseResponse);
    
    // Handle Stripe checkout URL if available
    if (purchaseResponse?.sessionUrl) {
      // Redirect to Stripe checkout
      window.location.href = purchaseResponse.sessionUrl;
      return purchaseResponse;
    } else {
      toast.error("Unable to initiate payment. Please try again.");
      return null;
    }
  } catch (err) {
    console.error("Service purchase failed:", err);
    toast.error(
      err.response?.data?.details ||
      "Something went wrong. Please try again."
    );
    throw err;
  }
};

  // Update search term
  const updateSearchTerm = (term) => {
    setSearchTerm(term);
  };

  // Initial load
  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  return {
    services,
    loading,
    error,
    pagination,
    searchTerm,
    fetchServices,
    getServiceDetails,
    purchaseService,
    updateSearchTerm,
    purchasedServices,
  purchasedServicesLoading,
  purchasedServicesError,
  purchasedServicesPagination,
  fetchPurchasedServices
  };
};